// src/utils/cardLogoUtils.ts

// Import all the images from the assets folder
import Visa from "../assets/img/PaymentIcons/visa.png";
import MasterCard from "../assets/img/PaymentIcons/master.png";  // Updated master logo name
import AmericanExpress from "../assets/img/PaymentIcons/Americanexpress.png";
import Discover from "../assets/img/PaymentIcons/discover.png";
import Eway from "../assets/img/PaymentIcons/eway.png";
import Sage from "../assets/img/PaymentIcons/sage.png";
import PayPal from "../assets/img/PaymentIcons/paypal.png";
import Amazon from "../assets/img/PaymentIcons/amazon.png";
import Ebay from "../assets/img/PaymentIcons/ebay.png";
import Cirrus from "../assets/img/PaymentIcons/cirrus.png";
import Google from "../assets/img/PaymentIcons/google.png";
import Shopify from "../assets/img/PaymentIcons/shopify.png";
import WesternUnion from "../assets/img/PaymentIcons/westernUnion.png";
import DinnerClub from "../assets/img/PaymentIcons/dinnerclub.png";
import JCB from "../assets/img/PaymentIcons/jcb.png";
import Skrill from "../assets/img/PaymentIcons/skrill.png";
import WorldPay from "../assets/img/PaymentIcons/worldpay.png";
import DirectDebit from "../assets/img/PaymentIcons/directdebit.png";
import Maestro from "../assets/img/PaymentIcons/maestro.png";
import SkrillMoney from "../assets/img/PaymentIcons/skrillmoney.png";
import VisaElectron from "../assets/img/PaymentIcons/visaelectron.png";  // Added Visa Electron logo
import UnionPay  from "../assets/img/PaymentIcons/unionpay.png";  // Added UnionPay logo

// Map all card logos to their respective image paths
const cardLogoMap: { [key: string]: string } = {
  visa: Visa,
  mastercard: MasterCard,
  amex: AmericanExpress,
  discover: Discover,
  eway: Eway,
  sage: Sage,
  paypal: PayPal,
  amazon: Amazon,
  ebay: Ebay,
  cirrus: Cirrus,
  google: Google,
  shopify: Shopify,
  westernunion: WesternUnion,
  diners: DinnerClub,  
  jcb: JCB,
  skrill: Skrill,
  worldpay: WorldPay,
  directdebit: DirectDebit,
  maestro: Maestro,
  skrillmoney: SkrillMoney,
  visaelectron: VisaElectron, 
  unionpay: UnionPay,  // Added UnionPay logo
};

export const getCardLogo = (brand: string): string => {
 
  return cardLogoMap[brand.toLowerCase()] || "/path/to/default-logo.png";  // Default fallback logo
};
